query studentList($page: Int, $sortBy: StudentSort, $sortDirection: Direction, $teamId: ID!) {
  studentList(page: $page, sortBy: $sortBy, sortDirection: $sortDirection, teamId: $teamId) {
    list {
      id
      first
      last
      positivity
      mostRecentCommunication
      communicationCount
      gradeLevel {
        id
        name
        order
      }
    }
    count
    remaining
    pageSize
  }
}
